var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171276566"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3829",
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 8.5,
    fill: "var(--fill-0, #6A7D80)",
    stroke: "var(--stroke-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66602 8.5C8.71006 8.5 8.75299 8.51762 8.78418 8.54883C8.81522 8.58 8.83301 8.62275 8.83301 8.66699V23.167H23.3252C23.3692 23.167 23.4112 23.1846 23.4424 23.2158C23.4734 23.2469 23.4911 23.2888 23.4912 23.333C23.4912 23.3773 23.4736 23.42 23.4424 23.4512C23.4112 23.4823 23.3691 23.5 23.3252 23.5H8.66602C8.62209 23.4999 8.57996 23.4823 8.54883 23.4512C8.51766 23.42 8.5 23.3773 8.5 23.333V8.66699C8.5 8.62266 8.51767 8.58002 8.54883 8.54883C8.57995 8.51769 8.62207 8.50008 8.66602 8.5ZM23.3516 14.5068C23.3674 14.5051 23.3833 14.5067 23.3984 14.5117C23.4138 14.5169 23.4279 14.5252 23.4395 14.5361C23.4512 14.5472 23.4608 14.561 23.4668 14.5762L23.4707 14.585L23.4736 14.5928C23.5029 14.6591 23.508 14.7342 23.4873 14.8037C23.4665 14.8732 23.4203 14.9333 23.3594 14.9727L18.2129 18.0234L18.1641 18.0527L18.123 18.0918C18.099 18.1146 18.0679 18.1289 18.0352 18.1328L18.001 18.1367L17.9668 18.1455C17.9536 18.149 17.9397 18.1486 17.9268 18.1445C17.9136 18.1403 17.9014 18.1327 17.8926 18.1221L17.877 18.1035L17.8604 18.0869L15.0146 15.2686L14.6631 14.9189L14.3105 15.2686L11.46 18.0986C11.4266 18.1314 11.3816 18.1494 11.335 18.1494C11.2886 18.1494 11.2443 18.1311 11.2109 18.0986C11.1807 18.0675 11.1631 18.0259 11.1631 17.9824C11.1631 17.9389 11.1806 17.8973 11.2109 17.8662L14.5322 14.5693C14.5672 14.5352 14.6144 14.5156 14.6631 14.5156C14.6874 14.5156 14.7113 14.5203 14.7334 14.5293L14.7939 14.5693L17.6758 17.4287L17.9502 17.7012L18.2832 17.5029L23.3008 14.5254L23.3057 14.5225C23.3194 14.5141 23.3355 14.5087 23.3516 14.5068Z",
    fill: "var(--fill-0, #6A7D80)",
    stroke: "var(--stroke-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetChart);
export default __webpack_public_path__ + "static/media/asset-chart.7407f1f3f488eec29313e33d19e4a336.svg";
export { ForwardRef as ReactComponent };